var React = require('react');

var GenericModalButton = function (props) {
    return (
        <button data-toggle="modal" className={props.buttonClass} data-target={props.dataTarget}>{props.text}</button>
    );
} 

export default GenericModalButton